import SectionIds from '../tracking/SectionIds';
import { ALERT_MODULE_NAME, EMAIL_STATE_NAME, PERMISSIONS_EMAIL_BANNER } from './constants';

const alertsInitialState = {
  [ALERT_MODULE_NAME]: {
    [EMAIL_STATE_NAME]: {
      isLoading: false,
      alreadyCreated: [],
      error: null,
      formError: null,
      section: SectionIds.ALERT_CREATION_SECTION_MOBILE_BOTTOM,
    },
    [PERMISSIONS_EMAIL_BANNER]: {
      isShow: false,
      currentStep: null,
    },
  },
};

export default alertsInitialState;



// WEBPACK FOOTER //
// ./app/Alerts/initialState.js